<div id="dailystat_info" class="tablewrap resizetable tabpage hidden">
  <div class="table">
    <div class="blockheader"></div>
    <table fixedcols="[]" id="dailystattable">
      <tr>
        <th class="time_column">{{'Date'|translate }}</th>
        <th class="time_column">{{'Parking'|translate }}</th>
        <th class="time_column">{{'Moving'|translate }}</th>
        <th class="mileage_column">{{'Mileage'|translate }}</th>
        <th class="time_column">{{'Engine time'|translate }}</th>
        <th class="time_column">{{'Working time'|translate }}</th>
        <th class="time_column">{{'Idling'|translate }}</th>
        <th>{{'Fuel consumption'|translate }}</th>
        <th>{{'Fueling'|translate }}</th>
      </tr>
    </table>
  </div>
    <app-pagination [viewmode]="'print excel'" [printElementID]="'dailystattable'"></app-pagination>
</div>
